var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.25,
    fill: "#FFE0E3",
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 10.752L7.25195 7.25195M7.25233 10.752L10.752 7.25195",
    stroke: "#F42828",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8346 9.00065C14.8346 5.77899 12.223 3.16732 9.0013 3.16732C5.77964 3.16732 3.16797 5.77899 3.16797 9.00065C3.16797 12.2223 5.77964 14.834 9.0013 14.834C12.223 14.834 14.8346 12.2223 14.8346 9.00065Z",
    stroke: "#F42828",
    strokeWidth: 0.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSocial);
export default __webpack_public_path__ + "static/media/DeleteSocial.c6bbca95b5e9131beae5bb19c8484537.svg";
export { ForwardRef as ReactComponent };